import { useEffect } from 'react';

import { Flex, Skeleton } from 'antd';

import { currencyFlagMap } from '@/shared/lib/financial';
import { Currency } from '@/shared/types/currency';
import { Card } from '@/shared/ui/card';
import { InputTextFake } from '@/shared/ui/input';

import { useLazyGetAccountInfoQuery } from '../../api/trading-platform.api';
import { useGetTradingPlatformSessionId } from '../../models/selectors/get-trading-platform-session-id';
import { useGetTradingPlatformSessionType } from '../../models/selectors/get-trading-platform-session-type';

import cls from './trading-platform-currency-select.module.css';

export function TradingPlatformCurrencySelect() {
    const accountId = useGetTradingPlatformSessionId();
    const connectionType = useGetTradingPlatformSessionType();

    const [
        getAccountInfoQuery,
        { data: accountInfo, isFetching: isGetAccountInfoFetching },
    ] = useLazyGetAccountInfoQuery();

    useEffect(() => {
        if (accountId && connectionType) {
            getAccountInfoQuery({ accountId, connectionType });
        }
    }, [accountId, getAccountInfoQuery, connectionType]);

    const selectedCurrency = accountInfo?.currency || Currency.USD;
    const FlagComponent = currencyFlagMap[selectedCurrency];

    if (isGetAccountInfoFetching) {
        return (
            <Card
                isWithoutPadding
                wrapperClassName={cls.root}
            >
                <Flex
                    align="center"
                    className={cls.skeleton}
                    gap={8}
                >
                    <Skeleton.Avatar
                        active
                        shape="square"
                        size={16}
                    />
                    <Skeleton.Input
                        active
                        size="small"
                        style={{ width: 36, minWidth: 36 }}
                    />
                </Flex>
            </Card>
        );
    }

    return (
        <Card
            isWithoutPadding
            wrapperClassName={cls.root}
        >
            <InputTextFake
                className={cls.input}
                pictogram={<FlagComponent className={cls.flag} />}
                value={selectedCurrency}
            />
        </Card>
    );
}
